import styled from '@emotion/styled'
import { WestRewardsLogo } from '../../../../../../logos/TheWestRewardsLogo/TheWestRewardsLogo'
import { breakpoint } from '../../../../../../__styling'
import { colors } from '../../../../../../__styling/settings/colors'
import { ThemeMargins } from '../../../../../../__styling/settings/metrics'
import { calcRem } from '../../../../../../__styling/style-functions/calc-rem'
import { themedValue } from '../../../../../../__styling/themed-value'

export interface BlackFridayStyledWestRewardsWrapperProps {
    verticalSpacing?: keyof ThemeMargins | undefined
}

export const StyledWestRewardsWrapper = styled(
    'div',
)<BlackFridayStyledWestRewardsWrapperProps>(({ theme, verticalSpacing }) => ({
    padding: calcRem(theme.margins.sm, theme.margins.md),
    background: themedValue(theme, {
        thewest: colors.thewest.greyErmine,
        perthnow: colors.perthnow.greyBasalt90,
        sevennews: colors.sevennews.charade,
        fallback: undefined,
    }),
    marginBottom: verticalSpacing && calcRem(theme.margins[verticalSpacing]),
}))

export const StyledWestRewardsContainer = styled('div')({
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 auto',
    justifyContent: 'start',

    [breakpoint('xxs')]: {
        justifyContent: 'center',
    },
})

export const StyledWestRewardsLogoContainer = styled('div')(({ theme }) => ({
    flexBasis: '35%',
    position: 'relative',
    marginLeft: theme.margins.md,
}))

export const StyledWestRewardsLogo = styled(WestRewardsLogo)({
    width: 115,
    height: 50,

    //Centering the Rewards Logo inside the containing div.
    position: 'absolute',
    top: 0,
    bottom: 0,
    margin: 'auto',

    [breakpoint('xxs')]: {
        width: 140,
    },
})

export const StyledWestRewardsMessage = styled('div')(({ theme }) => ({
    position: 'relative',
    flexBasis: '50%',
    textAlign: 'right',
    paddingRight: theme.margins.md,

    [breakpoint('xxs')]: {
        '&::after': {
            content: '""',
            height: '90%',
            width: 1,
            background: colors.black,
            bottom: 2,
            right: 0,
            position: 'absolute',
        },
    },

    p: {
        fontWeight: 500,
        fontSize: calcRem(11),
        [breakpoint('xs')]: {
            textIndent: 20,
        },
    },
}))
